import React, { ReactNode, useEffect, useState } from 'react';

import { AuthApiService } from '../../../lib/utils/auth-api.service';
import { setAuthenticatedUser } from '../../../lib/services/auth.service';
import { SessionType } from '../../../lib/types/session.types';
import { startConnectivityMonitoring } from '../../../lib/stores/connectivity.controller';
import { startViewportMonitoring } from '../../../lib/stores/viewport.store';
import ErrorPage from '../../_pages/_boilerplate/ErrorPage/error-page.container';
import LoadingPage from '../../_pages/_boilerplate/LoadingPage/loading-page.container';

interface SessionBootstrapProps {
  children: ReactNode;
}

// Restores both session tokens once on app load and seeds the staff/parent user
// vars; each app's AppApolloProvider builds its own client lazily from them.
export const SessionBootstrap: React.FC<SessionBootstrapProps> = ({ children }) => {
  const [isBootstrapped, setBootstrapped] = useState(false);
  const [error, setError] = useState(false);

  // Start connectivity + viewport monitoring once on mount (both idempotent);
  // formerly ran as module-load side effects in this file.
  useEffect(() => {
    startConnectivityMonitoring();
    startViewportMonitoring();
  }, []);

  useEffect(() => {
    AuthApiService.refreshSession()
      .then(({ staff, parent }) => {
        if (staff) setAuthenticatedUser(staff, SessionType.STAFF, { identify: false });
        if (parent) setAuthenticatedUser(parent, SessionType.PARENT, { identify: false });
        setBootstrapped(true);
      })
      .catch((err) => {
        console.error('SessionBootstrap failed to restore session:', err);
        setError(true);
      });
  }, []);

  if (error) return <ErrorPage />;
  return isBootstrapped ? <>{children}</> : <LoadingPage />;
};
